import React, { useEffect, useState } from 'react'
import { useApp } from '../../../context/AppProvider'
import useFetch from '../../../hook/UseFetch'
import { isEmpty } from '../../../services/common'
import { Parser } from '../../common'
import CitiesSuggestions from './CitiesSuggestions'
import Input from './Input'

const LocalSearch = ({ block }) => {
    const [searchValue, setSearchValue] = useState('')
    const { valueLocation } = useApp()

    const { data, api } = useFetch()

    useEffect(() => {
        api.citiesSelect(searchValue)
    }, [searchValue])

    useEffect(() => {
        !isEmpty(valueLocation) && setSearchValue('')
    }, [valueLocation])

    return (
        <div className="baseocom-location-search">
            <Parser content_block={block?.childrens} />
            <Input searchValue={searchValue} setSearchValue={setSearchValue} />
            <CitiesSuggestions
                searchValue={searchValue}
                data={data}
                setSearchValue={setSearchValue}
            />
        </div>
    )
}

export default LocalSearch
